export const config = {
    // apiUrl: 'http://localhost:6020/api',
    apiUrl: 'api',    
    solrApiUrl: './/solrapi/api'
    //solrApiUrl: 'https://beta.kluwerlawonline.com/solrapi/api/'
    //solrApiUrl: 'http://aiew1albnklo1-1935864601.eu-west-1.elb.amazonaws.com/solrapi/api/'
    //solrApiUrl: 'http://localhost:51553/api/'
    //solrApiUrl: 'http://localhost:82/api'
};


// WEBPACK FOOTER //
// ./src/_helpers/config.js